import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

interface Props {
  children: React.ReactNode;
  trailing?: React.ReactNode;
}

export const PricingSearchBar: React.FC<Props> = ({ children, trailing }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      <View style={styles.inputWrapper}>{children}</View>
      {trailing}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    position: 'relative',
  },
  inputWrapper: {
    flexShrink: 1,
    minWidth: 140,
    width: 556,
  },
}));
